import React from "react";
import { keyframes, css } from "@emotion/css";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const loaderStyle = css`
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-top: 3px solid white;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    animation: ${spin} 1s linear infinite;
`;

const Loader = ({ show }) => {
  if (!show) return null;
  return <div className={loaderStyle} />;
};

export default Loader;
